import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    featuresSection: {
        alignSelf: 'stretch',
        padding: '80px',
        marginTop: '-40px',
        backgroundColor: '#F4F0E7',
        borderTopLeftRadius: '40px',
        borderTopRightRadius: '40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '40px',
        position: 'relative',
        zIndex: 2,
        '@media (max-width: 768px)': {
            padding: '40px 16px',
            marginTop: '-20px',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
            gap: '24px',
        },
    },

    featuresHeader: {
        width: '100%',
        maxWidth: '1370px',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },

    featuresTitle: {
        maxWidth: '1140px',
        textAlign: 'center',
        width: '100%',
    },

    featuresTitleRegular: {
        color: '#222222',
        fontSize: '64px',
        fontFamily: 'Figtree',
        fontWeight: 400,
        lineHeight: '76.80px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '40px',
            lineHeight: '48px',
        },
    },

    featuresTitleItalic: {
        color: '#C6A972',
        fontSize: '64px',
        fontFamily: 'Behind The Nineties',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: '76.80px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '40px',
            lineHeight: '48px',
        },
    },

    featuresCards: {
        width: '100%',
        maxWidth: '1540px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        display: 'flex',
        '@media (max-width: 1200px)': {
            flexDirection: 'column',
            gap: '20px',
            width: '100%',
            maxWidth: '400px',
        },
    },
});

export interface AlyzeFeaturesSectionProps {
    titleRegular: string;
    titleItalic: string;
    children: React.ReactNode;
}

export const AlyzeFeaturesSection: React.FC<AlyzeFeaturesSectionProps> = ({
    titleRegular,
    titleItalic,
    children,
}) => {
    const styles = useStyles();

    return (
        <div className={styles.featuresSection}>
            <div className={styles.featuresHeader}>
                <div className={styles.featuresTitle}>
                    <span className={styles.featuresTitleRegular}>{titleRegular}</span>
                    <span className={styles.featuresTitleItalic}>{titleItalic}</span>
                </div>
            </div>
            <div className={styles.featuresCards}>
                {children}
            </div>
        </div>
    );
};
